module.exports = __webpack_public_path__ + "img/undTooth.76b20570.png";